import React from 'react';
import { IframeStyles as S } from './Iframe.styles';
const Iframe = ({ content, id, innerWidth = 'reduced' }) => {
    const writeThis = content.replaceAll('scrupt', 'script');
    return (React.createElement(S.Container, { id: id, innerWidth: innerWidth, flush: "top" },
        React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: writeThis } })));
};
export default Iframe;
